import {Component, inject, input, output} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {
  CreateUnitEconomicsCalculationData,
  UnitEconomicsCalculationData
} from "../../types/unit-economics-calculations.types";
import {CdkTextareaAutosize} from "@angular/cdk/text-field";
import {MatButton} from "@angular/material/button";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {unitEconomicsCalculationsFormFields} from "../../configs/unit-economics-calculations-form-fields";
import {UnitEconomicsCalculationsService} from "../../services/unit-economics-calculations.service";
import {RecordUpdateRequestParams} from "../../../../../../../../core/types/records-table.types";
import {unitEconomicsCalculationsResourceType} from "../../configs/unit-economics-calculations-config";

@Component({
  selector: 'app-unit-economics-calculations-form',
  imports: [
    CdkTextareaAutosize,
    MatButton,
    MatFormField,
    MatInput,
    MatLabel,
    ReactiveFormsModule
  ],
  templateUrl: './unit-economics-calculations-form.component.html',
  styleUrl: './unit-economics-calculations-form.component.scss'
})
export class UnitEconomicsCalculationsFormComponent {
  technicalParametersId = input.required<number>()
  unitEconomicFormGroup = input.required<FormGroup>();
  unitEconomicData = input.required<UnitEconomicsCalculationData>();
  noFirstData = input<boolean>(false);
  isEditModeActive = input<boolean>(false);
  updateUnitEconomicData = output<UnitEconomicsCalculationData>();
  deleteUnitEconomicData = output<void>();
  setLoadingState = output<boolean>();

  private unitEconomicsCalculationsService: UnitEconomicsCalculationsService = inject(UnitEconomicsCalculationsService);

  public readonly unitEconomicsCalculationsFormFields = unitEconomicsCalculationsFormFields;

  public getFieldClass(): string {
    if (!this.unitEconomicData().id) { return ''; }

    return this.isEditModeActive() ? '' : 'none-pointer-events';
  }

  public async handleValueChange(key: string): Promise<void> {
    if (!this.unitEconomicData().id) { return; }

    const params: RecordUpdateRequestParams = {
      path: unitEconomicsCalculationsResourceType.path,
      recordId: this.unitEconomicData().id,
      fieldName: key,
      value: this.unitEconomicFormGroup().get(key)?.value
    };

    const data = await this.unitEconomicsCalculationsService.updatedRecordField<UnitEconomicsCalculationData>(params)
      .catch(() => this.unitEconomicData());
    this.updateUnitEconomicData.emit(data);
  }

  public handleDeleteData(): void {
    this.deleteUnitEconomicData.emit();
  }

  public async handleCreateData(): Promise<void> {
    this.setLoadingState.emit(true);
    const params: CreateUnitEconomicsCalculationData = {
      technicalParametersId: this.technicalParametersId(),
      ...this.unitEconomicFormGroup().value
    };

    await this.unitEconomicsCalculationsService.createUnitEconomicsCalculation(params)
      .then((data) => this.updateUnitEconomicData.emit(data))
      .finally(() => this.setLoadingState.emit(false));
  }
}
